var facet_year_loaded = false,
	facet_stories_loaded = false;

(function($) {
	
	$(document).on('facetwp-loaded', function() {
		
		if(!facet_year_loaded) {
			var sel = $('<select class="facet-mobile-dropdown year-dropdown" />');
			$('.facetwp-facet-press_release_year.facetwp-type-radio .facetwp-radio').each(function(){
		      var value = $(this).data('value');
			  if(!value) {
				  value = 'Year';
			  }
			  sel.append('<option value='+$(this).data('value')+'>'+value+'</option>');
			});
					
			$('#mobile-year').append(sel);
			facet_year_loaded = true;
			$(document).on('change', '.facet-mobile-dropdown.year-dropdown', function() {
				var year = jQuery(this).val();
				$('.facetwp-facet-press_release_year.facetwp-type-radio .facetwp-radio[data-value="'+year+'"]').click();
			 });
		}
		
		if(!facet_stories_loaded) {
			var sel = $('<select class="facet-mobile-dropdown stories-dropdown" />');
			$('.facetwp-facet-stories.facetwp-type-radio .facetwp-radio').each(function(){
			  var text = $(this).text();
			  text = text.replace(/ *\([^)]*\) */g, "");
			  sel.append('<option value='+$(this).data('value')+'>'+text+'</option>');
			});
					
			$('#mobile-stories').append(sel);
			facet_stories_loaded = true;
			$(document).on('change', '.facet-mobile-dropdown.stories-dropdown', function() {
				var cat = jQuery(this).val();
				$('.facetwp-facet-stories.facetwp-type-radio .facetwp-radio[data-value="'+cat+'"]').click();
			 });
		}
		
	});

})(jQuery);